import { useMemo } from 'react';
import { useAuth } from '../../../utils/AuthProvider';
import { Button, ButtonSave } from '../../../components/base';
import { ArticleSaveRule, eArticleStatus } from '../../../context/models/articles/eArticleStatus';

type IArticleHeaderButtonProps = {
	articleStatus: string;
	isOwner?: boolean;
	isSaving: boolean;
	isActionDisable: boolean;
	handleSubmit: () => void;
	onActionConfirm: (actionChange: eArticleStatus) => void;
};

export const ArticleButton = ({
	articleStatus,
	isOwner,
	isSaving,
	isActionDisable,
	handleSubmit,
	onActionConfirm,
}: IArticleHeaderButtonProps) => {
	const { account } = useAuth();
	const actionsRule = useMemo(() => {
		return ArticleSaveRule({ status: articleStatus, isOwner: isOwner || false });
	}, [articleStatus, isOwner]);

	if (!account || account == null) return null;
	return (
		<>
			<ButtonSave type='button' theme='secondary' preset='dimoutline' isLoading={isSaving} isDisabled={isSaving} onClick={() => handleSubmit()} text={`Lưu thay đổi`} />

			{actionsRule.includes(eArticleStatus.BACK) && isActionDisable && (
				<>
					<Button
						theme='warning'
						preset='dimoutline'
						onClick={() => onActionConfirm(eArticleStatus.BACK)}
						text='Trả bài'
						icon='icon ni ni-reply-fill'
					/>
				</>
			)}
			{actionsRule.includes(eArticleStatus.PUBLISHED) && isActionDisable && (
				<>
					<Button
						theme='primary'
						preset='dimoutline'
						onClick={() => onActionConfirm(eArticleStatus.PUBLISHED)}
						text='Xuất bản ngay'
						icon='icon ni ni-check-thick'
					/>
				</>
			)}
		</>
	);
};
